import type { CSSProperties, JSX } from 'react';
import { TextField } from '../../../../_components/TextField.js';
import type { Palette } from '../../../../_theme/palette.js';
import type { SurveyQuestion } from '../../types.js';

interface MultipleTextboxesFieldProps {
  palette: Palette;
  question: SurveyQuestion;
  value: unknown;
  onChange: (value: Record<string, string>) => void;
}

const DEFAULT_LABELS = ['Field 1', 'Field 2', 'Field 3'];

// Stacked text inputs with custom labels per row. The main app's schema field
// is `textboxLabels`; we also accept the legacy `rows` for older surveys.
export function MultipleTextboxesField({ palette, question, value, onChange }: MultipleTextboxesFieldProps): JSX.Element {
  const labels =
    question.settings?.textboxLabels?.length
      ? question.settings.textboxLabels
      : question.settings?.rows?.length
        ? question.settings.rows
        : DEFAULT_LABELS;

  const current = (value as Record<string, string>) ?? {};

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
      {labels.map((label, index) => (
        <div key={`${label}-${index}`}>
          <label style={labelStyle(palette)}>{label}</label>
          <TextField
            palette={palette}
            value={current[label] ?? ''}
            onChange={(next) => onChange({ ...current, [label]: next })}
            placeholder={`Enter ${label.toLowerCase()}`}
            ariaLabel={label}
          />
        </div>
      ))}
    </div>
  );
}

function labelStyle(palette: Palette): CSSProperties {
  return {
    display: 'block',
    fontSize: 12,
    fontWeight: 500,
    color: palette.textMuted,
    marginBottom: 4,
  };
}
